import React, { Component } from 'react'
import { useAdvancedFilters } from '../../Filters/filterUrl'
import { graphql } from '@apollo/client/react/hoc'
import gql from 'graphql-tag'
import { Table } from 'reactstrap'
import PrimaryListingContainer from "../../Material/PrimaryListingContainer"
import withApolloClient from '../../withApolloClient'
import DatetimeRenderer from '../../Material/DatetimeRenderer'
import HistoryListModal from '../../Material/HistoryListModal'
import { HasPermissionsQuery } from "../../Functions/querys"
import CreateUpdateTPAAdjusterModal from './CreateUpdateTPAAdjusterModal'

const AllTPAAdjustersQuery = gql`
query AllTPAAdjusters($orderBy: [String], $first:Int!, $cursor:String, $searchTerm:String, $filters: [FilterInput]) {
  allTpaAdjusters(orderBy: $orderBy, first: $first, after: $cursor, searchTerm: $searchTerm, filters: $filters) {
    edges {
      node {
        id
        pk
        dateAdded
        dateModified
        name
        phone
        email
        role
        tpa {
          id
          name
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
`

class TPAAdjustersList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
        }
    }

    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }

    renderColumnValue = (column, adjuster) => {
        if (column.id === "date_added") return adjuster.dateAdded ? <DatetimeRenderer datetime={adjuster.dateAdded} /> : <span className="null-val-color">N/A</span>
        if (column.id === "date_modified") return adjuster.dateModified ? <DatetimeRenderer datetime={adjuster.dateModified} /> : <span className="null-val-color">N/A</span>
        if (column.id === "name") return adjuster.name || <span className="null-val-color">N/A</span>
        if (column.id === "tpa") return adjuster.tpa?.name || <span className="null-val-color">N/A</span>
        if (column.id === "phone") return adjuster.phone || <span className="null-val-color">N/A</span>
        if (column.id === "email") return adjuster.email || <span className="null-val-color">N/A</span>
        if (column.id === "role") return adjuster.role || <span className="null-val-color">N/A</span>
        return <span className="null-val-color">N/A</span>
    }

    render() {
        return (
            <PrimaryListingContainer
                listLoading={this.props.loading}
                loadMoreEntries={this.props.allTpaAdjusters?.pageInfo?.hasNextPage ? this.props.loadMoreEntries : null}
                refetchListQuery={this.props.refetchQuery}
            >
                <Table responsive>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th className='actions-th'>Actions</th>
                            {this.props.columnConfig?.filter(col => col?.preferenceSettings?.isVisible).map(column => (
                                column.sortable ?
                                    <th key={column.id} onClick={() => this.props.updateOrder(column.id)} style={{ cursor: "pointer" }}>
                                        {this.props.orderBy.some(order => order.includes(column.id)) ?
                                            <i className={"fa " + (this.props.orderBy.includes(column.id) ? 'fa-sort-asc' : 'fa-sort-desc')}></i>
                                            : <i className='fa fa-sort'></i>
                                        }
                                        &nbsp;&nbsp;{column.name}
                                    </th>
                                    : <th key={column.id}>{column.name}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.allTpaAdjusters?.edges?.length > 0 ? this.props.allTpaAdjusters.edges.map((adjuster, i) => (
                            <tr key={adjuster.node.id}>
                                <td>{i + 1}</td>
                                <td className='actions-td'>
                                    {this.props.hasPermissions && this.props.hasPermissions.includes("change_tpaadjuster") && (
                                        <span className='action-item'>
                                            <i className="fa fa-edit" title="Edit TPA Adjuster" style={{ cursor: "pointer" }} onClick={() => this.toggleModal(`editTpaAdjuster${adjuster.node.pk}`)}></i>
                                            {this.state.openModal === `editTpaAdjuster${adjuster.node.pk}` &&
                                                <CreateUpdateTPAAdjusterModal
                                                    isOpen={this.state.openModal === `editTpaAdjuster${adjuster.node.pk}`}
                                                    toggle={() => this.toggleModal("")}
                                                    id={adjuster.node.id}
                                                    refetchQuery={this.props.refetchQuery}
                                                />
                                            }
                                        </span>
                                    )}
                                    <span className='action-item'>
                                        <i className='fa fa-history' id={`viewHistory${adjuster.node.pk}`} aria-hidden="true" style={{ cursor: "pointer" }} onClick={() => this.toggleModal(`viewHistory${adjuster.node.pk}`)}></i>
                                        {this.state.openModal === `viewHistory${adjuster.node.pk}` &&
                                            <HistoryListModal
                                                isOpen={this.state.openModal === `viewHistory${adjuster.node.pk}`}
                                                toggle={() => this.toggleModal("")}
                                                title={`Change History Of Item ${i + 1}`}
                                                objectIds={[adjuster.node.id]}
                                                emptyText="No history available."
                                            />
                                        }
                                    </span>
                                </td>
                                {this.props.columnConfig?.filter(column => column?.preferenceSettings?.isVisible).map(column => (
                                    <td key={`${adjuster.node.id}-${column.id}`}>{this.renderColumnValue(column, adjuster.node)}</td>
                                ))}
                            </tr>
                        )) : !this.props.loading && (
                            <tr>
                                <td colSpan={this.props.columnConfig?.length + 2}>No TPA Adjusters found!</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </PrimaryListingContainer>
        )
    }
}

const TPAAdjustersListWithData = graphql(AllTPAAdjustersQuery, {
    options: ({ searchTerm, orderBy, filters }) => ({
        variables: { first: 30, searchTerm, orderBy, filters },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only'
    }),
    props: ({ data: { loading, allTpaAdjusters, fetchMore, variables } }) => ({
        loading,
        allTpaAdjusters,
        variables,
        refetchQuery: () => {
            let currentLength = allTpaAdjusters && allTpaAdjusters.edges ? allTpaAdjusters.edges.length : 30
            return fetchMore({
                query: AllTPAAdjustersQuery,
                variables: {
                    ...variables,
                    first: currentLength,
                },
                updateQuery: (previousResult, { fetchMoreResult }) => ({
                    allTpaAdjusters: {
                        edges: [...fetchMoreResult.allTpaAdjusters.edges],
                        pageInfo: fetchMoreResult.allTpaAdjusters.pageInfo,
                        __typename: previousResult.allTpaAdjusters.__typename
                    },
                }),
            })
        },
        loadMoreEntries: () => {
            return fetchMore({
                query: AllTPAAdjustersQuery,
                variables: {
                    cursor: allTpaAdjusters.pageInfo.endCursor,
                    ...variables
                },
                updateQuery: (previousResult, { fetchMoreResult }) => ({
                    allTpaAdjusters: {
                        edges: [...previousResult.allTpaAdjusters.edges, ...fetchMoreResult.allTpaAdjusters.edges],
                        pageInfo: fetchMoreResult.allTpaAdjusters.pageInfo,
                        __typename: previousResult.allTpaAdjusters.__typename
                    },
                }),
            })
        },
    })
})(
    graphql(
        HasPermissionsQuery, {
        options: () => ({
            variables: { userPermissions: ["change_tpaadjuster"] },
        }),
        props: ({ data: { hasPermissions } }) => ({
            hasPermissions,
        })
    }
    )(withApolloClient(TPAAdjustersList))
)

// Advanced filters live in the URL; feed them as the single `filters` variable.
export default function TPAAdjustersListWithFilters(props) {
    const [advancedFilters] = useAdvancedFilters()
    return <TPAAdjustersListWithData {...props} filters={advancedFilters} />
}
